import React from "react";

type Props = {
  children: React.ReactNode;
};

const AppRoute = ({ children }: Props) => {
  return <>{children}</>;
};

export default AppRoute;
